import { render, staticRenderFns } from "./BudgetGlobal.vue?vue&type=template&id=397f5aba&scoped=true&"
import script from "./BudgetGlobal.vue?vue&type=script&lang=js&"
export * from "./BudgetGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetGlobal.vue?vue&type=style&index=0&id=397f5aba&prod&scoped=true&lang=css&"
import style1 from "./BudgetGlobal.vue?vue&type=style&index=1&id=397f5aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f5aba",
  null
  
)

export default component.exports